import { useEffect } from "react";
import DesktopViewCV from "./Components/DesktopViewCV";
import MobileViewCv from "./Components/MobileViewCV";
import { useViewport } from "./Components/ViewportContext";


function App() {

  const { isMobile } = useViewport();

  useEffect(() => {
    if (window.location.pathname !== '/') {
      window.location.replace('/');
    }
  }, []);

  return (

    isMobile ? <MobileViewCv /> : <DesktopViewCV />

  );

}

export default App;